import { createActions } from 'redux-actions';

export const { loadAllTopics, loadedAllTopics, errorAllTopics } = createActions(
  'LOAD_ALL_TOPICS',
  'LOADED_ALL_TOPICS',
  'ERROR_ALL_TOPICS',
);
